module.exports = __webpack_public_path__ + "efb84fd3bd.woff";